import { AirlineSeatIndividualSuiteSharp } from '@material-ui/icons';
import React, { useState, useEffect} from 'react';
import './dnd.css';
import VariablePicker from './VariablePicker';



export default (props) => {

  var name = null
  var type = null
  
  const setValues = ()=>{
    if (props.element == null || props.element.data == null || props.element.data.screenAttributes == null) return

    var properties = props.element.data.screenAttributes

    var keys = Object.keys (properties)
    console.log(properties)

    for (var key in properties) {
      console.log(key)
      console.log(properties[key])

      if (properties[key] == "")
      {
        if (key.indexOf('check') == 0) key=key.slice(5)

        document.getElementById(key).value = ""; 
      }
      else
      {
        var newKey = key 
        if (key.indexOf('check') == 0) newKey=key.slice(5)

        document.getElementById(newKey).value = properties[key]
      }

    }
  }

  useEffect(() => { 
    setValues() 

  });


  const onInputchange = (event) => {
    var properties = props.element.data.screenAttributes 
    properties[event.target.name] = event.target.value
    console.log("inout changed" + event.target.name + ' and '  + event.target.value)

    console.log(properties)
    // update the main model to reflect changes in properties
    props.updateProperties(properties)
    event.target.setAttribute(event.target.name, event.target.value)
  }  


  const renderLabel = (item)=>{

    if (item.name.indexOf('check') == 0){
    return  <label>{item.name.slice(5)}</label>     
    }
    else
    return  <label>{item.name}</label>     

  
  }
const renderInput = (item)=>{
  
  if (item.name.startsWith ("events")){
  const action = item.name.substring(6)
  return <button className="editbutton" id = {item.name} type = "button">{"Edit " + action + " Actions"}</button>     
  }
  else if (item.name.indexOf('check') == 0){

    return  <input type='checkbox' id={item.name.slice(5)}></input>     

  }

  else
  return (
    <div>
  <input className="input" name= {item.name}  id = {item.name} type = "text"  onChange={onInputchange}></input>
  {/* <VariablePicker/> */}
  </div>
  )
}  


const renderProperties = ()=>{


  if (props.element == null)
  return
  if ( props.element.data ==null)
  return 

  var properties = props.element.data.screenAttributes
  console.log("rendering...")
  console.log(JSON.stringify(properties))
  
  var attributesArray = []
  for (var i in properties)
  { 
    var temp = {}
    temp.name = i
    temp.value=properties[i]
    attributesArray.push(temp)
    console.log(temp)

  }


  return attributesArray.map(item=>{
    return <div >
    <div class="row" >
    {renderLabel(item)}

    </div>

    <div class="row" >

    {renderInput(item)}
    
        
    </div>


    <br></br>
    </div>
  });
}

  if (props.element == null || props.element.data ==null)
  name = '' 
  else
  name = props.element.data.label

  return (
        <div className='annotations'>
          <div >
          <h3>Screen Annotation</h3>
          </div>
    
          <div className="formtext">
            {  
              renderProperties()
            }
            <br></br>
          </div>
        </div>
        
      

      );
};